// Imports
import Modal from '../../../../../../../shareables/front-end/modal';


// Function component
const AskGenderModal: React.FC = () => (
	<Modal identifier='ask-gender' title='Gender field'>
		<p>
			Some communities hold gender-specific events (e.g., “men’s golf outing” or “ladies’ night out”) and like to be
			able to send communications about those events to just the residents who would be interested.
		</p>
		
		<p>
			If your community opts to send these types of communications, providing your gender will help ensure you only
			receive relevant emails, texts, etc.
		</p>
		
		<p>
			If you choose not to provide your gender, you’ll simply receive emails sent to both genders. That way, you won’t
			miss anything important.
		</p>
	</Modal>
);

export default AskGenderModal;
